import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import ArrowIcon from '../../../../../app/components/svgIcons/ArrowIcon';

const Instagram = () => {
  const [data, setData] = useState([{}]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalValue, setModalValue] = useState(null);
  const [showButtons, setShowButtons] = useState(false);
  const randomValue = Math.random() * 1000;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = process.env.REACT_APP_INSTAGRAM_ACCESS_TOKEN;
        const response = await axios.get(
          'https://graph.instagram.com/me/media',
          {
            params: {
              fields:
                'id,caption,media_type,media_url,thumbnail_url,permalink,timestamp',
              access_token: accessToken,
            },
          },
        );
        setData(response.data.data);
      } catch (error) {
        console.error('Error fetching Instagram data:', error);
        // Optionally, you can set an error state to display a message to the user
      }
    };

    fetchData();
  }, []);

  const handleToggle = (value = null) => {
    if (
      value &&
      value?.media_url &&
      value?.permalink &&
      value?.media_type === 'CAROUSEL_ALBUM'
    ) {
      window.open(value?.permalink, '_blank');
      return;
    }
    setModalOpen(true);
    setModalValue(value);
  };

  const handleDateFormat = (timestampString) => {
    // Create a Date object from the timestamp string
    var timestampDate = new Date(timestampString);

    // Array of month names
    var monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    // Get the day, month, and year from the Date object
    var day = timestampDate.getDate();
    var monthIndex = timestampDate.getMonth();

    // Format the date in the desired format
    var formattedDate = day + ' ' + monthNames[monthIndex];

    // Display the formatted date
    return formattedDate;
  };

  return (
    <div style={{ backgroundColor: '#f2f2f2', paddingBottom: '6.25rem' }}>
      <div className="container d-flex flex-column justify-content-center align-items-center">
        <h2
          style={{
            fontSize: '54px',
            fontFamily: 'Instrument Sans',
            fontWeight: 700,
          }}
        >
          INSTAGRAM
        </h2>
        <span
          style={{
            letterSpacing: '3px',
            fontSize: '20px',
            fontWeight: 'lighter',
            fontFamily: 'Instrument Sans',
          }}
        >
          DISCOVER OUR LATEST POSTS
        </span>
      </div>

      <div
        onMouseEnter={() => setShowButtons(true)}
        onMouseLeave={() => setShowButtons(false)}
      >
        {data && data.length && (
          <>
            <Swiper
              pagination={true}
              slidesPerView={2}
              autoplay={false}
              navigation={{
                prevEl: '.custom_prev_if1',
                nextEl: '.custom_next_if1',
              }}
              spaceBetween={0}
              className="style3-swiper"
              breakpoints={{
                768: {
                  slidesPerView: 4,
                },
              }}
            >
              {data?.map((obj, i) => (
                <SwiperSlide
                  key={i}
                  id={`swiper-rapper-test-${randomValue}`}
                  onClick={() => handleToggle(obj)}
                >
                  <div class="card">
                    <div class="insta-feed-image-holder">
                      {obj?.media_url && obj?.media_type === 'IMAGE' && (
                        <img
                          loading={'lazy'}
                          src={obj?.media_url}
                          alt=""
                          class="instagram"
                        />
                      )}

                      {obj?.media_url &&
                        obj?.thumbnail_url &&
                        obj?.media_type === 'VIDEO' && (
                          <>
                            <img
                              loading={'lazy'}
                              src={obj?.thumbnail_url}
                              alt=""
                              class="instagram"
                            />
                            <span className="video-play-icon">
                              <a
                                href={obj?.permalink}
                                target="_blank"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <i class="fa fa-play" aria-hidden="true"></i>
                              </a>
                            </span>
                          </>
                        )}

                      {obj?.media_url &&
                        obj?.media_type === 'CAROUSEL_ALBUM' && (
                          <>
                            <img
                              loading={'lazy'}
                              src={obj?.media_url}
                              alt=""
                              class="instagram"
                            />
                          </>
                        )}

                      <a
                        href={obj?.permalink}
                        target="_blank"
                        onClick={(e) => e.stopPropagation()}
                        className="card-hover-detail"
                      >
                        <div className="card-hover-content">
                          <div className="card-hover-bottom">
                            <span>
                              <i class="fa fa-clock-o" aria-hidden="true"></i>{' '}
                              {handleDateFormat(obj?.timestamp)}
                            </span>
                            <a
                              href={obj?.permalink}
                              target="_blank"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <i class="fa fa-instagram" aria-hidden="true"></i>
                            </a>
                          </div>
                          {obj?.media_url &&
                            obj?.media_type === 'CAROUSEL_ALBUM' && (
                              <span className="insta-album-icon">
                                <svg
                                  class="svg-inline--fa fa-clone fa-w-16 sbi_lightbox_carousel_icon"
                                  aria-hidden="true"
                                  aria-label="Clone"
                                  data-fa-proƒcessed=""
                                  data-prefix="far"
                                  data-icon="clone"
                                  role="img"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 512 512"
                                >
                                  <path
                                    fill="currentColor"
                                    d="M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"
                                  ></path>
                                </svg>
                              </span>
                            )}
                        </div>
                      </a>
                    </div>
                    <div class="insta-feed-content-holder">
                      {obj?.caption && (
                        <p3 class="testimonial">{obj?.caption}</p3>
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div
              style={{
                position: 'relative',
                visibility:
                  showButtons && data?.length > 4 ? 'visible' : 'hidden',
              }}
              className="w-100 d-flex flex-row justify-content-between"
            >
              <span
                className="custom_prev_if1 d-flex justify-content-center align-items-center"
                style={{
                  height: '50px',
                  width: '50px',
                  borderRadius: '25px',
                  backgroundColor: '#d443a0',
                  zIndex: 60,
                  position: 'absolute',
                  left: '5px',
                  bottom: '260px',
                }}
              >
                <i
                  style={{ color: 'white', fontSize: '20px' }}
                  className="fa fa-angle-left"
                ></i>
              </span>
              <span
                style={{
                  height: '50px',
                  width: '50px',
                  borderRadius: '25px',
                  backgroundColor: '#d443a0',
                  zIndex: 60,
                  position: 'absolute',
                  right: '5px',
                  bottom: '260px',
                }}
                className="custom_next_if1 d-flex justify-content-center align-items-center"
              >
                <i
                  style={{ color: 'white', fontSize: '20px' }}
                  className="fa fa-angle-right"
                ></i>
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Instagram;
